import CustomizeBlockPageBaseStore from './CustomizeBlockPageBaseStore';
import { CUSTOMIZATION_TYPE } from './CustomizeUIConstants';
import getCustomPagesApis from './getCustomPagesApis';

export default class CustomizeContentFilteringStore extends CustomizeBlockPageBaseStore {
    constructor(data = { }) {
        super({}, /** @class CustomizeContentFilteringStore */{
            ...getCustomPagesApis('CONTENT_FILTERING'),
            metadata: {
                customizationType: CUSTOMIZATION_TYPE.CONTENT_FILTERING,
                type: 'Block Page',
                name: 'Content Filtering',
                description: 'Displayed when Page Content is blocked.',
            },
        }, data);
    }
}
